import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllIncentiveSettings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    docObject:{}
  }
  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.addCommunicationSettings(values)

        if (!x.error) {
          notification.success({
            message: `Setting Updated Successfully`
          })
          this.getCommunicationSettings()
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  getCommunicationSettings() {
      Request.getCommunicationSettings().then(
        ({doc, error, message}) => {
          if (!error && doc) {            
            this.props.form.setFieldsValue({
              incentiveThroughCPApplication: doc.incentiveThroughCPApplication
            })
            this.setState({docObject: doc});
          } else {
            // notification.error({
            //   message: 'Error Getting Data',
            //   description: message
            // })
          }
        }
      )
  }

  componentWillMount() {
    this.getCommunicationSettings()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
  }
  chooseTab(value) {    
    this.setState({
        activeTab: value
    });
    let doc = this.state.docObject;
    setTimeout(() => {
        this.props.form.setFieldsValue({
          incentiveThroughCPApplication: doc.incentiveThroughCPApplication
        })
    }, 1000)
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id} = this.state;

    const whatsAppSettingInputTypes = {
      fields: [
        {
          label: 'Incentive Through CP Application',
          key: 'incentiveThroughCPApplication',
          type: "select",
          required: true,
          showSearch: true,
          options: [
            'Yes', 'No'
          ],
          onChange: (v) => {
            this.props.form.setFieldsValue({ incentiveThroughCPApplication: v });
          },
        }
      ]
    };

    return (
        <PageHeaderWrapper title={` Incentive Settings `}>
            <Card bordered={true}>
                <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                    <TabPane tab={'Incentive Settings'} key={0}>
                        <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                            <GetAllFormFields
                                inputSchema={whatsAppSettingInputTypes}
                                refresh={this.refreshFxn}
                                getFieldDecorator={getFieldDecorator}
                                />
                            <Button
                                type=""
                                htmlType="submit"
                                style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                                }}
                                loading={this.props.loading}
                            >
                                SAVE
                            </Button>
                            <Button
                                type="primary"
                                style={{marginBottom: 10, marginLeft: '1%'}}
                                loading={this.props.loading}
                                onClick={() => {
                                this.props.form.resetFields()
                            }}>
                                RESET
                            </Button>
                        </Form>
                    </TabPane>
                </Tabs>
            </Card>
        </PageHeaderWrapper>
    );
  }
}

export default AllIncentiveSettings
